import {
  type DocumentVariableMetadata,
  documentVariable,
  documentVariableGroup
} from './document-variable'

/**
 * Representante legal de la SOCIEDAD VENDEDORA (uno por documento — legítimamente escalar) + las
 * frases de cierre de la parte compradora.
 *
 * Los tokens del cierre llevan guion bajo (`parte_compradora_nombre`) y no `prefijo.campo`, por
 * eso son sueltos y no un grupo; el `group` los anida igual en el picker.
 */

export const REPRESENTANTE_VARIABLE_METADATA: DocumentVariableMetadata[] = documentVariableGroup({
  prefix: 'representante',
  category: 'society',
  groupLabel: 'Representante (sociedad)',
  fields: {
    nombre: {
      label: 'Representante · Nombre',
      example: 'HERBERT DAVID SILVESTRE VELA'
    },
    edad: {
      label: 'Representante · Edad (en letras)',
      example: 'cincuenta y tres'
    },
    estado_civil: {
      label: 'Representante · Estado civil',
      example: 'casado'
    },
    nacionalidad: {
      label: 'Representante · Nacionalidad',
      example: 'guatemalteco'
    },
    profesion: {
      label: 'Representante · Profesión',
      example: 'Ingeniero en sistemas'
    },
    departamento: {
      label: 'Representante · Departamento',
      example: 'Guatemala'
    },
    dpi_letras: {
      label: 'Representante · DPI (en letras)'
    },
    dpi_numeros: {
      label: 'Representante · DPI (números)',
      example: '1943 64194 0101'
    },
    cargo: {
      label: 'Representante · Cargo',
      example: 'ADMINISTRADOR ÚNICO Y REPRESENTANTE LEGAL'
    },
    entidad: {
      label: 'Representante · Entidad (sociedad)'
    },
    nombramiento_fecha: {
      label: 'Representante · Nombramiento (fecha)'
    },
    notario_tratamiento: {
      label: 'Representante · Notario (el/la)'
    },
    notario_nombre: {
      label: 'Representante · Notario (nombre)'
    },
    registro_numero: {
      label: 'Representante · Registro (número)'
    },
    registro_folio: {
      label: 'Representante · Registro (folio)'
    },
    registro_libro: {
      label: 'Representante · Registro (libro)'
    }
  }
})

// Cierre / parte compradora.
export const CIERRE_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'parte_compradora_nombre',
    label: 'Parte compradora · Nombre',
    category: 'document',
    type: 'string',
    group: 'Cierre',
    example: 'MARÍA MARGARITA ALONSO ASCENCIO'
  }),
  documentVariable({
    key: 'parte_compradora_frase',
    label: 'Parte compradora · Frase de cierre',
    category: 'document',
    type: 'string',
    group: 'Cierre'
  })
]
